import { request } from '@services'

export const state = {
  nameLists: [],
}

export const getters = {
  getNameList(state) {
    return state.nameLists
  },
}

export const mutations = {
  SET_NAME_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_NAME_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.nameLists = newData
    state.errors = null
  },
  SET_NAME_LIST_RECEIVED_FAIL(state, error) {
    state.loading = false
    state.errors = error
  },
}

export const actions = {
  async fetchingNameList({ commit }) {
    commit('SET_NAME_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/agent/name_list/',
        payload: {},
      })
      commit('SET_NAME_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_NAME_LIST_RECEIVED_FAIL', error)
    }
  },
}
